import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import image from '../table.png'
import { ArrowForward } from "@mui/icons-material";

const ComparisonTable = () => {
  return (
    <Container fluid style={{
      background: `linear-gradient(135deg, #0a3d91, #1e72c0)`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundOrigin: "center",
      color: "white",
      margin: "auto",
      minHeight: "450px",
    }}>
      <div className="container mt-4 py-5">
        <h3 className="mb-3 text-center text-white text-lg">Why GAINSS <span style={{ color: '#3EA5F8' }}>Outpaces Legacy Tools</span></h3>
        <div className="d-none d-md-block">
        <img className="mt-4" src={image} alt="Comparison Table" />
        </div>
        <div className="d-md-none" style={{width: '100%', overflowX: 'scroll'}}>
        <img className="mt-4" src={image} alt="Comparison Table" />
        </div>
       
        <Row className="mt-5">
          <Col>
            <p className="text-center medium">
              {" "}
              Ready to experience the GAINSS advantage?

            </p>
            <p className="text-center mt-5">
              <a href="https://app.gainss.ai/register" 
              style={{ background: 'white', color: '' }} 
              className="text-blue btn-rounded btn btn-primary">
                Switch to GAINSS Today <ArrowForward fontSize="16" />
              </a>
            </p>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default ComparisonTable;
